import { render, staticRenderFns } from "./SingleProductPanelItem.vue?vue&type=template&id=4a848bfa&scoped=true&"
import script from "./SingleProductPanelItem.vue?vue&type=script&lang=js&"
export * from "./SingleProductPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./SingleProductPanelItem.vue?vue&type=style&index=0&id=4a848bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a848bfa",
  null
  
)

export default component.exports